"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tag = void 0;

var _util = require("../../../util");

const getColorKey = variant => {
  switch (variant) {
    case 'grey':
      return 'overlay1';

    case 'greyInverse':
      return 'overlay0';

    case 'greyDark':
      return 'overlay2';

    case 'buy':
      return 'data.positiveSubtle';

    case 'sell':
      return 'data.negativeSubtle';

    default:
      return "background.".concat(variant);
  }
};

const getTextColor = variant => {
  switch (variant) {
    case 'buy':
      return 'text.positive';

    case 'sell':
      return 'text.negative';

    default:
      return 'text.3';
  }
};

const tag = ({
  cssProps,
  theme
}) => {
  const {
    variant = 'grey',
    size = 'small'
  } = cssProps;
  const isSmall = size === 'small';
  return {
    background: (0, _util.color)(theme, getColorKey(variant)),
    color: (0, _util.color)(theme, getTextColor(variant)),
    borderRadius: isSmall ? 2 : 3,
    padding: isSmall ? (0, _util.spacing)(theme, 'xxsmall') / 2 : (0, _util.spacing)(theme, ['xxsmall', 'xsmall'])
  };
};

exports.tag = tag;
//# sourceMappingURL=Tag.style.js.map